export const AUTO_UPDATE_INTERVAL = 30000;
export const AUTO_UPDATE_PENDING_INTERVAL = 30000;
export const ANNOUNCEMENTS_UPDATE_INTERVAL = 60000;
export const HOME_PATH = '/';

export const TOAST_DURATION = 5000;

export const LANGUAGE_OPTIONS = [
    { value: 'de', label: 'Deutsch' },
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
    { value: 'pl', label: 'Polski' },
    { value: 'ja', label: '日本語 (Japanese)' },
    { value: 'ko', label: '한국어 (Korean)' },
    { value: 'it', label: 'Italiano' },
    { value: 'cs', label: 'Čeština' },
    { value: 'sk', label: 'Slovenčina' },
    { value: 'sl', label: 'Slovenščina' },
    { value: 'hu', label: 'Magyar' },
    { value: 'ro', label: 'Română' },
    { value: 'hr', label: 'Hrvatski' },
    { value: 'sr', label: 'Српски' },
    { value: 'es', label: 'Español' },
];
export const DEFAULT_LANGUAGE = 'de';
